// JavaScript source code
import React from "react";
import CarouselSection from "./carousel";
import CertificationMarks from "./certificationMarks";
import CurrentProjects from "./currentProjects";
import WhatWeDo from "./whatWeDo";
import Partners from "./partners";
import CoreValuesPage from "./coreValues";

function Home() {
  return (
    <div>
      <CarouselSection />
      <WhatWeDo />
      <CertificationMarks />
      <CurrentProjects />
      <CoreValuesPage />

      <Partners />
    </div>
  );
}

export default Home;
